import { Component, forwardRef, Renderer2, ViewChild, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EmployeePositionService } from '../../../service/employee-position/employee-position.service';
import { TranslateService } from '@ngx-translate/core';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectEmployeePositionComponent),
  multi: true,
};

@Component({
  selector: 'app-select-employee-position',
  templateUrl: './select-employee-position.component.html',
  styleUrls: ['./select-employee-position.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class SelectEmployeePositionComponent implements ControlValueAccessor {
    @Input() employeePositionsId: number;
    @ViewChild('input') textarea;

    public employeePositionsOptions: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public employeePositionsService: EmployeePositionService,
        public translate: TranslateService,
    ) {
        this.page = 1;
        this.per_page = 1000;
        this.query = undefined;
        this.filters = [];
        this.filters.push({key: 'activated-lk', value: '1'});
        this.getEmployeePositions(this.query, this.filters);
    }

    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean ) {
        const div = this.textarea.nativeElement;
        const action = isDisabled ? 'addClass' : 'removeClass';
        this.renderer[action](div, 'disabled');
    }

    public change($event) {
        this.onChange($event.target.value);
        this.onTouched($event.target.value);
    }

    getEmployeePositions(query?: string, filters?: any[]) {
        this.employeePositionsService.getEmployeePositions(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                const employeePositions = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }

                this.employeePositionsOptions = [];
                this.employeePositionsOptions.push({id: undefined, name: 'choose'});
                employeePositions.forEach(element => {
                    if (this.employeePositionsId === element.id) {
                        this.employeePositionsOptions.push({id: element.id, name: element.name, selected: true});
                    } else {
                        this.employeePositionsOptions.push({id: element.id, name: element.name, selected: false});
                    }
                });
            },
            error => {
                this.employeePositionsOptions = [];
                this.employeePositionsOptions.push({id: '', name: 'Error'});
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/employee-positions/select-employee-position/select-employee-position.component.ts